import { render } from "./AllProjects.vue?vue&type=template&id=40213a3c"
import script from "./AllProjects.vue?vue&type=script&lang=js"
export * from "./AllProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__